import axios from "axios";
import ApiUserRepository from "@/repositories/ApiUserRepository.js";


axios.defaults.withCredentials = true;

export default {

    async getLots() {
        let user = await ApiUserRepository.getUser();
        const lots = await axios.get(process.env.VUE_APP_BACKEND_API_URL +(user.roles.includes("CONSULTATION") ? process.env.VUE_APP_URL_LOTS_CONSULTATION :  process.env.VUE_APP_URL_LOTS));
        return lots.data;
    },

    async saveLot(lot) {
        const envoie = await axios.post(process.env.VUE_APP_BACKEND_API_URL +process.env.VUE_APP_URL_LOTS,lot);
        return envoie.data;
    },

    async updateLot(lot) {
        const envoie = await axios.put(process.env.VUE_APP_BACKEND_API_URL +process.env.VUE_APP_URL_LOTS,lot);
        return envoie.data;
    },

    async getLotsByDRHG(gestionnaire) {
        const lots = await axios.get(process.env.VUE_APP_BACKEND_API_URL +process.env.VUE_APP_URL_LOTS +"/byDRH/" + gestionnaire)
        return lots.data;
    },

    async getLotsByDRHGLotOuvert(gestionnaire) {
        const lots = await axios.get(process.env.VUE_APP_BACKEND_API_URL +process.env.VUE_APP_URL_LOTS +"/byDRH/ouvert/" + gestionnaire)
        return lots.data;
    },

    async getLotsByDRH() {
        const lots = await axios.get( process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_LOTS +"/byDRH")
        return lots.data;
    },

    async getLotsByDRHLotOuvert() {
        const lots = await axios.get( process.env.VUE_APP_BACKEND_API_URL +process.env.VUE_APP_URL_LOTS +"/byDRH/ouvert")
        return lots.data;
    },

    async deleteById(id)
    {
        const lot = await axios.delete(process.env.VUE_APP_BACKEND_API_URL +process.env.VUE_APP_URL_LOTS + "/byDRH/" + id)
        return lot.data;
    },

    exportLot(id)
    {
        return process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_FILE + process.env.VUE_APP_URL_LOT_EXCEL + id;
    }
}